export enum ProfessionalIDEnum {
  ANALYZER = "analyzer",
  PIVOT = "pivot",
}
